import React from 'react';
import { LuArrowLeft } from 'react-icons/lu';
import {  useSupabaseClient } from "@supabase/auth-helpers-react";

const Revoke = ({label = 'Expired Token Reauthenticate' }) => {
    const supabase = useSupabaseClient();

  async function logout() {
    await supabase.auth.signOut();
  }

  return (
    <button
      onClick={logout}
      className="flex items-center justify-center gap-2 px-4 py-2 w-full bg-black text-white rounded hover:bg-blue-700 transition"
    >
      <LuArrowLeft className="h-4 w-4" />
      <span>{label}</span>
    </button>
  );
};

export default Revoke;